export default {"src":"/_next/static/media/discover-network.dad0909a.svg","height":48,"width":48};